import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UsbIcon(props: IconProps) {
    return <Icon {...props} iconKey={"usb"}/>
}
